<!-- Sidebar -->
<aside
  class="fixed left-0 top-0 h-screen w-80 bg-white border-r border-gray-200 z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto p-4 fs-condensed"
>
  <!-- Header -->
  <div class="flex items-center justify-between mb-2">
    <img src="/logos/default.webp" alt="ALLAS REPUESTOS" class="h-10 w-auto" />
    <button
      (click)="closeSidebar.emit()"
      class="p-1 hover:bg-gray-100 rounded transition-colors text-gray-600"
      aria-label="Cerrar menú"
    >
      <lucide-icon [name]="xIcon"></lucide-icon>
    </button>
  </div>

  <hr class="my-4 border-gray-200" />

  <!-- ACCESO RÁPIDO -->
  <div class="mb-6">
    <div class="space-y-1">
      <a
        href="/encuentra-tu-tienda"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Encuentra tu Tienda
      </a>
      <a
        href="/servicios/diagnostico-instalacion-baterias"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Diagnóstico e Instalación de Baterías
      </a>
    </div>
  </div>

  <hr class="my-4 border-gray-200" />

  <!-- MÁS POPULARES -->
  <div class="mb-6">
    <h3 class="font-bold text-gray-900 mb-3 text-sm font-inter">
      Más Populares
    </h3>
    <div class="space-y-1 pl-4">
      <a
        href="repuestos/bateria-para-carro-auto-o-camioneta"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Baterías
      </a>
      <a
        href="/repuestos/aceite-de-motor"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Aceite de Motor
      </a>
      <a
        href="/repuestos/aceite-de-transmision-automatica"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Aceite de Transmisión Automática
      </a>
      <a
        href="/repuestos/aceite-de-transmision-manual"
        class="block py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        Aceite de Transmisión Manual
      </a>
    </div>
  </div>

  <!-- COMPRAR -->
  <div class="mb-6">
    <h3 class="font-bold text-gray-900 mb-3 text-sm font-inter">Comprar</h3>
    <div class="space-y-1 pl-4">
      <a
        href="repuestos/bateria-para-carro-auto-o-camioneta"
        class="flex items-center gap-2 py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        <img
          src="/allas-icons/battery-gray.svg"
          alt="Baterías"
          class="w-auto h-3"
        />
        Baterías
      </a>
      <a
        href="repuestos/lubricantes-fluidos-lavado-pegamentos-y-quimicos"
        class="flex items-center gap-2 py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        <img
          src="/allas-icons/chemicals.svg"
          alt="Lubricantes y Químicos"
          class="w-auto h-3"
        />
        Lubricantes y Químicos
      </a>
      <a
        href="repuestos/accesorios-de-interior"
        class="flex items-center gap-2 py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        <img
          src="/allas-icons/interior.svg"
          alt="Accesorios de Interior"
          class="w-auto h-3"
        />
        Accesorios de Interior
      </a>
      <a
        href="repuestos/accesorios-de-exterior"
        class="flex items-center gap-2 py-2 text-gray-700 hover:text-allasRed transition-colors font-inter text-sm"
      >
        <img
          src="/allas-icons/exterior.svg"
          alt="Accesorios de Exterior"
          class="w-auto h-3"
        />
        Accesorios de Exterior
      </a>
    </div>
  </div>

  <!-- COMPRAR POR -->
  <div class="mb-6">
    <h3 class="font-bold text-gray-900 mb-3 text-sm font-inter">Comprar por</h3>
    <div class="space-y-1 pl-4">
      @for(item of shopBy; track item.name) {
      <a
        [href]="item.href"
        class="block py-1 text-sm text-gray-700 hover:text-allasRed transition-colors font-inter"
      >
        {{ item.name }}
      </a>
      }
    </div>
  </div>

  <!-- SERVICIOS -->
  <div class="mb-6">
    <!-- <h3 class="font-bold text-gray-900 mb-3 text-sm font-inter">Servicios</h3> -->
    <div class="space-y-1">
      @for(service of services; track service.name; let index = $index) {
      <div>
        <div class="flex items-center justify-between">
          <span
            class="block py-1 text-sm font-bold text-gray-900 mb-3 font-inter flex-1"
          >
            {{ service.name }}
          </span>
          @if(service.subcategories) {
          <button
            (click)="toggleSection('services-' + index)"
            class="p-1 hover:bg-gray-100 rounded transition-colors"
          >
            @if(isSectionExpanded('services-' + index)) {
            <lucide-icon [name]="chevronDownIcon"></lucide-icon>
            } @else {
            <lucide-icon [name]="chevronRightIcon"></lucide-icon>
            }
          </button>
          }
        </div>
        @if(service.subcategories && isSectionExpanded('services-' + index)) {
        <div class="ml-4 mt-1 space-y-1">
          @for(sub of service.subcategories; track sub.name) {
          <a
            [href]="sub.href"
            (click)="onSidebarLinkClick()"
            class="block py-1 text-sm text-gray-600 hover:text-allasRed transition-colors font-inter"
          >
            {{ sub.name }}
          </a>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>

  <!-- CONTÁCTENOS -->
  <div class="mb-6">
    <h3 class="font-bold text-gray-900 mb-3 text-sm font-inter">Contáctenos</h3>
    <div class="space-y-1">
      <a
        href="tel:+50422834540"
        class="block py-1 text-sm text-gray-700 hover:text-allasRed transition-colors font-inter"
      >
        Teléfono: +504 2283-4540
      </a>
      <a
        href="https://wa.me/50422834540"
        class="block py-1 text-sm text-gray-700 hover:text-allasRed transition-colors font-inter"
      >
        WhatsApp
      </a>
      <a
        href="/sucursales"
        (click)="onSidebarLinkClick()"
        class="block py-1 text-sm text-gray-700 hover:text-allasRed transition-colors font-inter"
      >
        Nuestras sucursales
      </a>
    </div>
  </div>
</aside>
